import React from 'react'
import { Route } from 'react-router-dom'

import Loadable from 'src/utils/loadable'
import PrivateRoute from 'src/components/Router/PrivateRoute'

export default ({ features, path, feature, isPrivate = false, component}) => {
  if (features.hasOwnProperty(feature) && !features[feature]) {
    return <Route path={path} component={Loadable(() => import('src/modules/NotFound'))}/>
  }

  if (isPrivate) {
    return <PrivateRoute path={path} component={component} />
  }

  return <Route path={path} component={component} />
}
